/**
 * The check-in QR code and link for a game night. The code opens
 * /join/<pin> on the same site that serves this page.
 */
import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Button, Flex, Text } from '@radix-ui/themes';

export function joinUrl(pin: string): string {
  return `${window.location.origin}/join/${pin}`;
}

export default function CheckInQr({ pin, size = 160 }: { pin: string; size?: number }) {
  const [copied, setCopied] = useState(false);
  const url = joinUrl(pin);
  const copy = () => {
    navigator.clipboard?.writeText(url).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      },
      () => {},
    );
  };
  return (
    <Flex direction="column" align="center" gap="2">
      <div style={{ background: '#fff', padding: 8, borderRadius: 8, lineHeight: 0 }}>
        <QRCodeSVG value={url} size={size} level="M" marginSize={1} bgColor="#ffffff" fgColor="#0a0a1a" />
      </div>
      <Flex align="center" gap="2" wrap="wrap" justify="center">
        <Text size="1" color="gray" style={{ overflowWrap: 'anywhere' }}>{url.replace(/^https?:\/\//, '')}</Text>
        <Button size="1" variant="ghost" onClick={copy}>{copied ? 'Copied' : 'Copy'}</Button>
      </Flex>
    </Flex>
  );
}
